import LRUCache from './lru-cache'

export default class SearchHistoryCache {
  localStorageKey: string
  LRU: LRUCache
  constructor(storageKey: string, capacity: number) {
    this.localStorageKey = storageKey
    this.LRU = new LRUCache(capacity)
  }

  public addFilteredKeywordHandler(searchKeyword: string): string[] {
    this.LRU.put(searchKeyword, searchKeyword)
    const words: string[] = this.LRU.getValueArray()
    return words === null ? [] : words
  }

  public removeSearchKeywordHandler(keyword: string) {
    this.LRU.deleteKey(keyword)
    const words: string[] = this.LRU.getValueArray()
    return words === null ? [] : words
  }

  public writeToLocalStorage(searchKeywords: string[]) {
    const str: string = JSON.stringify(searchKeywords)
    window.localStorage.setItem(this.localStorageKey, str)
  }

  public getKeys() {
    return this.LRU.getValueArray()
  }

  public readLocalStorageToCache(): string[] {
    const str: string | null = window.localStorage.getItem(this.localStorageKey)
    if (str === null || str === '') return []
    else {
      const strs = JSON.parse(str)
      if (strs === null) {
        return []
      }
      const len = strs.length
      for (let i = len - 1; i >= 0; i--) {
        if (strs[i] === null || strs[i] === '') continue

        this.LRU.put(strs[i], strs[i])
      }
    }
    return this.LRU.getValueArray()
  }

  public clearCache() {
    window.localStorage.removeItem(this.localStorageKey)
    this.LRU.clear()
  }
}
